/**
 * Report tiers for the Finalize step. The two paid tiers open a Stripe payment
 * link (the PRICE lives on Stripe — labels here are display-only). The third is
 * a referral: it emails info@tessa.ai so the project can be forwarded to a
 * development partner (e.g. Daiwa, Modulus). See [[tessa-report-stripe-links]].
 */
export interface ReportTier {
  id: string;
  name: string;
  price: string;
  desc: string;
  /** Stripe checkout link, or a mailto: for the referral tier. */
  url: string;
  cta: string;
  /** Referral tier — an enquiry, not a purchase. */
  contact?: boolean;
}

export const REPORT_CATALOG: ReportTier[] = [
  {
    id: "construction",
    name: "Construction design report",
    price: "$9",
    desc: "Site, massing views, metrics and the unit schedule — one page per design.",
    url: "https://buy.stripe.com/00w3cw2qnaCL8IQckLes005",
    cta: "Get report",
  },
  {
    id: "financial",
    name: "Financial feasibility report",
    price: "€99.99",
    desc: "Construction cost breakdown — build cost, prelims, contingency and overheads, per unit and per m². Adds a cost page per design.",
    url: "https://buy.stripe.com/00w5kE8OL12b5wE2Kbes004",
    cta: "Get report",
  },
  {
    id: "partner",
    name: "Take it further",
    price: "By referral",
    desc: "Hand your shortlist to a development partner who can build it out. We forward your project to a partner (e.g. Daiwa, Modulus) as a referral.",
    url: "mailto:info@tessa.ai?subject=Tessa%20project%20referral",
    cta: "Contact us",
    contact: true,
  },
];
